import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  display: grid;
  grid-auto-flow: row;
  border: 1px solid ${lightGrey2Color};
  border-radius: 0.25rem;
  background: white;
`;
